import React, { useEffect, useState } from 'react'
import { Box } from '@missionlabs/smartagent-app-components'
import useSmartAgentAPI from 'hooks/useSmartAgentAPI';

import { getScoreExists, getScore } from 'services/api/api.qa'
import RootState from 'store/state';
import { IScoreDetails } from 'store/qa/qa.state';
import Evaluation from './Evaluation';
import { Loader } from 'components';
import { useSelector, useDispatch, batch } from 'react-redux';
import classNames from 'classnames';
import { QAStatus } from 'views/QA/ScoreView/FormBuilderQA/FormBuilderQA.types';
import { setRedirect } from 'store/global/global.actions';
import { setShowNewQAScore } from 'store/qa/qa.actions';
import QAScoreTag from 'components/QAScoreTag';
import './contact-evaluation.scss';

interface Props {
    contactID?: string,
    hideLink?: boolean,
}

export const ContactEvaluation: React.FC<Props> = (props) => {
    const [ scoreID, setScoreID ] = useState<string | undefined>(undefined);

    const contactID = useSelector<RootState, string>(
        state => state.contact?.ID ?? props.contactID ?? ""
    )

    const dispatch = useDispatch();

    const [
        error,
        loading,
        response,
        request
    ] = useSmartAgentAPI<IScoreDetails | undefined, RootState>(
        async (state) => {
            const response = await getScoreExists(
                state.app.ID,
                state.auth.token!,
                props.contactID || contactID
            )

            if(!response.data?.scoreID){
                return {
                    status: 404,
                    data: undefined,
                    headers:{},
                    config:{},
                    statusText:''
                }
            }else{
                setScoreID(response.data.scoreID)
            }

            return getScore(
                state.app.ID,
                state.auth.token!,
                response.data.scoreID
            )
        }
    )

    useEffect(() => {
        if(contactID) request();
        // eslint-disable-next-line
    }, [contactID])

    const goToScore = () => batch(() => {
        if (response?.data){
            dispatch({
                type:'GET_SCORE',
                payload:response.data
            })
            dispatch(setRedirect(`/qa/scores/${response.data.ID}`))
        } else{
            dispatch(setShowNewQAScore(true))
            dispatch(setRedirect('/qa/scores', {
                contactID
            }))
        }
        
    })

    const renderHeader = (): React.ReactNode => {
        const score = response?.data;

        return (
            <div className="row between middle">
                <h1>Quality Assurance</h1>

                {score && <QAScoreTag percent={score.scorePercentage} status={score.status} failType={score.failType} />}
            </div>
        )
    }

    const isPass = () => response?.data?.status === QAStatus.PASS
    const isFail = () => response?.data?.status === QAStatus.FAIL

    const boxClasses = classNames({
        "sa-qa-status-widget-box": true,
        "sa-qa-status-widget-box-fail": isFail(),
        "sa-qa-status-widget-box-pass": isPass(),
    })

    return (
        <Box alt={!(isPass() || isFail())} collapse header={renderHeader()} className={boxClasses}>
            {loading ? (
                <Loader />
            ) :
            !!error && error.status !== 404 ? (
                <div className="">
                    Unable to fetch evaluation data
                </div>
            ) :
            (
                <div className="sa-qa-status-widget-wrapper">
                    <Evaluation scoreID={scoreID} hideLink={props.hideLink} goToScore={goToScore} data={response?.data} />
                </div>
            )
            }
        </Box>
    )
}